import { ChangeEvent, FC, ReactNode, memo, useState } from 'react';
import useColors from '../../../hooks/useColors';

interface CustomSelectProps {
  required?: boolean;
  id: string;
  type?: string;
  placeholder: string;
  name: string;
  value: string | number;
  disabled?: boolean;
  min?: number;
  max?: number;
  handleChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
  options: Array<{ label: string; value: string | number }>;
  icon?: ReactNode;
  autoComplete?: 'on' | 'off';
  list?: string;
}

const CustomSelect: FC<CustomSelectProps> = (props) => {
  const { primaryColor } = useColors();
  const [isFocus, setIsFocus] = useState<boolean>(false);

  return (
    <div className="relative">
      {props.icon && (
        <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
          {props.icon}
        </div>
      )}
      <select
        {...props}
        onChange={props.handleChange ? props.handleChange : () => null}
        onFocus={() => setIsFocus(true)}
        onBlur={() => setIsFocus(false)}
        value={props.value}
        className="bg-gray-50 border text-gray-900 text-sm rounded-lg block w-full p-2.5 disabled:bg-[#D2D2D2]"
        style={{
          borderColor: isFocus ? primaryColor : '#D2D2D2',
          outlineColor: isFocus ? primaryColor : 'transparent',
          paddingInlineStart: props.icon ? '2.5rem' : '0.625rem',
        }}
      >
        {/* blank option */}
        <option value="">{props.placeholder}</option>
        {props.options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default memo(CustomSelect);
